import { render, staticRenderFns } from "./Root.vue?vue&type=template&id=60b68ab3&scoped=true"
import script from "@/views/Users/Root/Root.ts?vue&type=script&lang=ts&external"
export * from "@/views/Users/Root/Root.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Users/Root/root.scss?vue&type=style&index=0&id=60b68ab3&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b68ab3",
  null
  
)

export default component.exports